module.exports = __webpack_public_path__ + "static/media/icon-top.38e0295e.svg";